export default {"src":"/_next/static/media/sinxi.d5f6c971.svg","height":100,"width":250,"blurWidth":0,"blurHeight":0};